<mat-card class="mat-mdc-elevation-specific mat-elevation-z0 rounded-lg">
    <app-form-error class="d-block mb-3" [error]="error"></app-form-error>
    <mat-card-content>
        <form class="recover-form" [formGroup]="form">
            <div class="account-admin-method">
                <mat-form-field class="select-form-field">
                    <mat-select class="select"
                                [placeholder]="'app.form.labels.communicationChannel' | translate"
                                [formControlName]="recoverFormField.SysCode">
                        @for (channel of channels; track channel.chnlId) {
                            <mat-option [value]="channel.sysCode">
                                {{ channel.channelName }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            @if (sysCodeControl?.value === systemChannelCode.Sms) {
                <div class="phone-field-container"
                     id="phone-field">

                    <app-country-selector [countryCodes]="countryCodes"
                                          [codeControl]="codeControl"
                                          (codeSelected)="onCodeSelect()" />

                    <mat-form-field class="phone-field">
                        <input matInput
                               type="text"
                               [placeholder]="'app.form.labels.phoneNumber' | translate"
                               [imask]="{ mask: '000000000000' }"
                               minlength="5"
                               maxlength="12"
                               [formControlName]="recoverFormField.Phone"
                               required
                               autocomplete="tel-national"
                               #phoneInput />

                        @if (phoneControl.hasError('required')) {
                            <mat-error>{{ 'auth.errors.phone_required' | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
            }

            @if (settings?.CLIENT_ATTR_EMAIL && settings?.CLIENT_ATTR_EMAIL !== 'U' && sysCodeControl.value === systemChannelCode.Email) {
                <mat-form-field class="email-field"
                                id="email-field"
                                tabindex="0">

                    <input matInput
                           type="text"
                           [placeholder]="'app.form.labels.email' | translate"
                           [formControlName]="recoverFormField.Email"
                           required />

                    @if (emailControl.hasError('required')) {
                        <mat-error translate>auth.errors.email_required</mat-error>
                    }

                    @if (emailControl.hasError('pattern')) {
                        <mat-error translate>auth.errors.email_invalid</mat-error>
                    }
                </mat-form-field>
            }


            <mat-form-field class="password-field">
                <input matInput
                       [type]="hidePassword ? 'password' : 'text'"
                       [placeholder]="'app.form.labels.newPassword' | translate"
                       [formControlName]="recoverFormField.Password"
                       minlength="8"
                       maxlength="255"
                       required
                       autocomplete="new-password" />

                <mat-icon matSuffix
                          (click)="hidePassword = !hidePassword"
                          class="hide-password-icon"
                          [fontIcon]="hidePassword ? 'visibility_off' : 'visibility'">

                </mat-icon>

                @if (passwordControl.hasError('required')) {
                    <mat-error>{{ 'auth.errors.new_password_required' | translate }}</mat-error>
                }
                @if (passwordControl.hasError('minlength')) {
                    <mat-error>{{ 'auth.errors.password_length'| translate: { length: passwordMinLength } }}</mat-error>
                }
            </mat-form-field>

            <mat-form-field class="confirm-field">
                <input matInput
                       [type]="hidePassword ? 'password' : 'text'"
                       [placeholder]="'app.form.labels.confirmPassword' | translate"
                       [formControlName]="recoverFormField.ConfirmPassword"
                       maxlength="255"
                       autocomplete="off" />

                <mat-icon matSuffix
                          (click)="hidePassword = !hidePassword"
                          class="hide-password-icon"
                          [fontIcon]="hidePassword ? 'visibility_off' : 'visibility'">

                </mat-icon>
                @if (confirmControl.hasError('mismatch')) {
                    <mat-error>{{ 'auth.errors.passwords_not_match' | translate }}</mat-error>
                }
            </mat-form-field>

            <div class="d-flex">
                <button class="mat-mdc-elevation-specific mat-elevation-z0"
                        mat-raised-button
                        color="primary"
                        type="submit"
                        [disabled]="form.invalid || pending"
                        (click)="onSubmit()">
                    {{ 'app.actions.changePassword' | translate }}
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
